import { application } from "./application"
import HelloController from "./hello_controller"
import SidebarController from "./sidebar_controller"
import ToastController from "./toast_controller"
import HtmlEditorController from "./html_editor_controller"
import TomSelectController from "./tom_select_controller"
import AvatarUploadController from "./avatar_upload_controller"
import FlashController from "./flash_controller"
import InsightsSourceFormController from "./insights_source_form_controller"
import NotificationLinkController from "./notification_link_controller"
import TooltipController from "./tooltip_controller"
import CopyLinkController from "./copy_link_controller"
import NavController from "./nav_controller"
import AdminSubscribersController from "./admin_subscribers_controller"
import AgentRulesConfiguratorController from "./agent_rules_configurator_controller"
import ProjectCardDescriptionController from "./project_card_description_controller"
import DiffcheckerController from "./diffchecker_controller"
import PageEditorController from "./page_editor_controller"
import WebsiteBuilderController from "./website_builder_controller"
import BuilderCanvasController from "./builder_canvas_controller"
import BuilderPaletteController from "./builder_palette_controller"
import BuilderTreeController from "./builder_tree_controller"
import BuilderInspectorController from "./builder_inspector_controller"
import BuilderDndController from "./builder_dnd_controller"
import BuilderSectionsController from "./builder_sections_controller"
import BuilderTabsController from "./builder_tabs_controller"
import BuilderMediaController from "./builder_media_controller"
import BuilderThemeController from "./builder_theme_controller"
import PasswordVisibilityController from "./password_visibility_controller"

application.register("hello", HelloController)
application.register("sidebar", SidebarController)
application.register("toast", ToastController)
application.register("html-editor", HtmlEditorController)
application.register("tom-select", TomSelectController)
application.register("avatar-upload", AvatarUploadController)
application.register("flash", FlashController)
application.register("insights-source-form", InsightsSourceFormController)
application.register("notification-link", NotificationLinkController)
application.register("tooltip", TooltipController)
application.register("copy-link", CopyLinkController)
application.register("nav", NavController)
application.register("admin-subscribers", AdminSubscribersController)
application.register("agent-rules-configurator", AgentRulesConfiguratorController)
application.register("project-card-description", ProjectCardDescriptionController)
application.register("diffchecker", DiffcheckerController)
application.register("page-editor", PageEditorController)
application.register("website-builder", WebsiteBuilderController)
application.register("builder-canvas", BuilderCanvasController)
application.register("builder-palette", BuilderPaletteController)
application.register("builder-tree", BuilderTreeController)
application.register("builder-inspector", BuilderInspectorController)
application.register("builder-dnd", BuilderDndController)
application.register("builder-sections", BuilderSectionsController)
application.register("builder-tabs", BuilderTabsController)
application.register("builder-media", BuilderMediaController)
application.register("builder-theme", BuilderThemeController)
application.register("password-visibility", PasswordVisibilityController)
